export enum ChargeState {
  ADDED,
  UPDATED
}
